<template>
  <div
    :ref="`multi-driver-cell-${rowId}`"
    @click="showDrivers"
    @dblclick="hideDrivers"
    class="flex-grow-1"
  >
    <div
      v-for="driver in drivers"
      :key="driver.id"
      :style="`background-color: ${driver.backgroundColor ?? '#ffffff'}; color: ${driver.textColor ?? '#000000'};`"
      class="fw-bolder rounded user-select-none border border-1 px-1"
      :class="{ 'minified': drivers.length > 1 }"
      style="font-size: 10px"
    >
      <div>
        <div class="d-flex justify-content-between">
          <div class="text-sm-secondary">
            <Popper placement="right">
            <span class="p-1" role="button">
              {{ driver.firstName }} {{ driver.surname }}
            </span>
              <template #content>
                <button class="btn btn-danger" @click="detachDriver(driver)">
                  Odepnij kierowcę
                </button>
              </template>
            </Popper>
          </div>
          <div class="text-xl">
            <Popper placement="right">
          <span class="text-darker px-1" role="button">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </span>
              <template #content>
                <CommentCreator :driver-id="driver.id"/>
                <DriverCellColorPicker :driver="driver"/>
              </template>
            </Popper>
          </div>
        </div>
      </div>
      <div
        v-show="driver.comments.length"
        class="fw-bolder notebook-btn text-xs py-1"
        data-bs-toggle="modal"
        data-bs-target="#driverCommentModal"
        @click="launchDriverCommentModal(driver)"
        role="button">
        NOTES {{ driver.comments.length }}
      </div>
    </div>
    <div v-if="drivers.length > 1">
      <span role="button" class="text-danger text-decoration-underline fw-bold text-sm" @click="detachTeam">Odepnij obsadę</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import colors from '@/modules/cells/colors'
import CommentCreator from '@/components/TasksCalendar/Comments/Driver/CommentCreator.vue'
import eventKinds from '@/modules/events/eventKinds'
import Popper from 'vue3-popper'
import moment from 'moment-timezone'
import { $axios } from '@/modules/http/axios'
import DriverCellColorPicker from '@/components/Partials/ColorPickers/DriverCellColorPicker.vue'

export default {
  name: 'DriverCell',
  components: { DriverCellColorPicker, CommentCreator, Popper },
  props: ['drivers', 'vehicle', 'rowId'],
  data () {
    return {
      colors: colors,
      openedPopperCommentId: null
    }
  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },
  methods: {
    launchDriverCommentModal (driver) {
      emitter.emit(eventKinds.driverCommentModalRequested, { driver: driver })
    },
    deleteComment (driverId, id) {
      $axios.delete(`Comment/${id}`)
        .then(() => {
          emitter.emit(eventKinds.driverCommentDeleted, { driverId: driverId })
          Swal.fire({
            title: 'Komentarz usunięty',
            text: 'Komentarz został usunięty',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    async detachDriver (driver) {
      const postData = { driverIds: [driver.id] }
      const vehicle = this.vehicle ?? driver.vehicle
      let selectedArrivalDate = moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')
      let selectedPlannedDepartureDate = moment().add(6, 'days').tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')

      const arrivalDialogResult = await Swal.fire({
        title: 'Czy przypisać datę zjazdu automatycznie?',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Nie',
        showConfirmButton: true,
        confirmButtonText: 'Tak'
      })

      if (!arrivalDialogResult.isConfirmed) {
        await Swal.fire({
          title: 'Proszę określić datę zjazdu',
          icon: 'question',
          showCancelButton: true,
          cancelButtonText: 'Anuluj',
          showConfirmButton: true,
          confirmButtonText: 'Przejdź dalej',
          html: `
            <div>Data zjazdu:</div>
            <input class="form-control" id="arrival-date" type="datetime-local" value="${moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}" required>
          `,
          preConfirm: () => {
            return new Promise(resolve => {
              const arrivalDate = document.getElementById('arrival-date').value

              if (arrivalDate === '') {
                Swal.fire('Proszę uzupełnić datę zjazdu', '', 'warning')
              } else {
                resolve(arrivalDate)
              }
            }).then(result => {
              selectedArrivalDate = result
            })
          }
        })
      }

      const departureDialogResult = await Swal.fire({
        title: 'Proszę określić datę wyjazdu',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Anuluj',
        showConfirmButton: true,
        confirmButtonText: 'Zatwierdź',
        html: `
          <div>Data Wyjazdu:</div>
          <input class="form-control" id="planned-departure-date" type="datetime-local" value="${moment(selectedArrivalDate).add(6, 'days').tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}" required>
        `,
        preConfirm: () => {
          return new Promise(resolve => {
            const plannedDepartureDate = document.getElementById('planned-departure-date').value

            if (plannedDepartureDate === '') {
              Swal.fire('Proszę uzupełnić datę wyjazdu', '', 'warning')
            } else {
              resolve(plannedDepartureDate)
            }
          }).then(result => {
            selectedPlannedDepartureDate = result
          })
        }
      })

      postData.arrivalDate = selectedArrivalDate
      postData.plannedDepartureDate = selectedPlannedDepartureDate

      if (departureDialogResult.isConfirmed) {
        $axios.post(`Vehicle/Vehicle/${vehicle.id}/Driver/Unassign`, postData).then(() => {
          this.drivers.map((d, i) => {
            if (d.id === driver.id) {
              this.drivers.splice(i, 1)
            }
          })
          emitter.emit('vehicleChanged')
          Swal.fire(`Odpięto kierowcę ${driver.firstName} ${driver.surname} od ciągnika ${vehicle.plateNumber}.`, '', 'success')
        }).catch(e => {
          Swal.fire(
            `Nie udało się odpiąć kierowcy ${driver.firstName} ${driver.surname} od ciągnika "${vehicle.plateNumber}"`,
            `System nie był w stanie wykonać żądanej operacji <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`,
            'error'
          )
        })
      } else {
        await Swal.fire('Anulowano odpięcie kierowcy', 'Operacja została anulowana', 'info')
      }
    },

    async detachTeam () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postData = { driverIds: this.drivers.map(d => d.id) }

      if (this.vehicle) {
        const dialogResult = await Swal.fire({
          title: `Czy na pewno odpiąć obsadę od ciągnika ${this.vehicle.plateNumber}`,
          showCancelButton: true,
          cancelButtonText: 'Anuluj',
          showConfirmButton: true,
          confirmButtonText: 'Tak',
          icon: 'question'
        })

        let selectedArrivalDate = moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')
        let selectedPlannedDepartureDate = moment().add(6, 'days').tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')

        const arrivalDialogResult = await Swal.fire({
          title: 'Czy przypisać datę zjazdu automatycznie?',
          icon: 'question',
          showCancelButton: true,
          cancelButtonText: 'Nie',
          showConfirmButton: true,
          confirmButtonText: 'Tak'
        })

        if (!arrivalDialogResult.isConfirmed) {
          await Swal.fire({
            title: 'Proszę określić datę zjazdu',
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Anuluj',
            showConfirmButton: true,
            confirmButtonText: 'Przejdź dalej',
            html: `
            <div>Data zjazdu:</div>
            <input class="form-control" id="arrival-date" type="datetime-local" value="${moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}" required>
          `,
            preConfirm: () => {
              return new Promise(resolve => {
                const arrivalDate = document.getElementById('arrival-date').value

                if (arrivalDate === '') {
                  Swal.fire('Proszę uzupełnić datę zjazdu', '', 'warning')
                } else {
                  resolve(arrivalDate)
                }
              }).then(result => {
                selectedArrivalDate = result
              })
            }
          })
        }

        const departureDialogResult = await Swal.fire({
          title: 'Proszę określić datę wyjazdu',
          icon: 'question',
          showCancelButton: true,
          cancelButtonText: 'Anuluj',
          showConfirmButton: true,
          confirmButtonText: 'Zatwierdź',
          html: `
          <div>Data Wyjazdu:</div>
          <input class="form-control" id="planned-departure-date" type="datetime-local" value="${moment(selectedArrivalDate).add(6, 'days').tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}" required>
        `,
          preConfirm: () => {
            return new Promise(resolve => {
              const plannedDepartureDate = document.getElementById('planned-departure-date').value

              if (plannedDepartureDate === '') {
                Swal.fire('Proszę uzupełnić datę wyjazdu', '', 'warning')
              } else {
                resolve(plannedDepartureDate)
              }
            }).then(result => {
              selectedPlannedDepartureDate = result
            })
          }
        })

        postData.arrivalDate = selectedArrivalDate
        postData.plannedDepartureDate = selectedPlannedDepartureDate

        if (dialogResult.isConfirmed && departureDialogResult.isConfirmed) {
          await axios.post(`${process.env.VUE_APP_API_BASE_URL}Vehicle/Vehicle/${this.vehicle.id}/Driver/Unassign`, postData, config)
          emitter.emit('vehicleChanged')
          await Swal.fire(`Odpięto obsadę od ciągnika ${this.vehicle.plateNumber}`, 'Obsada została pomyślnie odpięta', 'success')
        }
      }
    },

    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    UpdateComment (comment) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.put(`${process.env.VUE_APP_API_BASE_URL}Comment/${comment.id}`, comment, config)
        .then(() => {
          Swal.fire( 'Sukces', 'Edycja przeszła pomyślnie', 'success' )
        }).catch((e) => {
          Swal.fire('Błąd', 'Coś poszło nie tak', 'error')
          console.log(e)
        })
    },
    AddMail (mail) {
      this.comment.mails += mail + ','
    },

    showDrivers () {
      const childNodes = this.$refs[`multi-driver-cell-${this.rowId}`].childNodes
      this.minified = true

      childNodes.forEach(childNode => {
        if (childNode.classList) {
          childNode.classList.remove('minified')
        }
      })
    },
    hideDrivers () {
      const childNodes = this.$refs[`multi-driver-cell-${this.rowId}`].childNodes
      this.minified = false

      childNodes.forEach(childNode => {
        if (childNode.classList) {
          childNode.classList.add('minified')
        }
      })
    },
    async reFetchDrivers () {
      this.drivers.map((d, i) => {
        $axios.get(`Driver/${d.id}`).then(response => {
          this.drivers[i] = response.data
        })
      })
    }
  }
}
</script>

<style scoped>
.text-sm {
  font-size: .8rem;
}

.text-sm-secondary {
  font-size: .6rem;
}

.text-xs {
  font-size: .5rem;
}

.text-xl {
  font-size: 1.2rem;
}

.text-darker {
  color: #bbb;
}

.minified {
  height: 15px;
  overflow: hidden;
}
</style>
